module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogoEsmart.d9e587be.png";